export default {
  qingping_particle_sensor: 'Qingping Particulate Matter Sensor',
  design: 'Design',
  measurement_range: 'Measurement Range',
  specs: 'Specs',
  in_the_box: 'In the Box',
  size: 'Size',
  color: 'Color',
  size_value: '49.5 × 37 × 11.8 mm',
  color_value: 'Silver',
  pm25_pm10: 'PM2.5/PM10',
  pm_range: '0 ~ 999 μg/m³',
  name: 'Name',
  weight: 'Weight',
  weight_value: '26 g',
  mm_unit: 'mm',
} 